// Mega menu de escritorio: se abre al pasar el raton por encima.
//
// 🔴 EL CLIC YA NO CIERRA LO QUE EL HOVER ACABA DE ABRIR (5-sep-2026).
//    El panel cuelga de un <summary>, y un <summary> alterna el <details> por su
//    cuenta al hacer clic. Como el hover ya lo habia abierto, el mismo gesto de
//    "ir a la categoria y pinchar" lo CERRABA: el raton entra -> se abre -> se
//    hace clic -> se cierra. Se intercepta el clic mientras el panel esta
//    abierto para que no alterne; cerrar sigue siendo salirse con el raton o
//    pulsar Escape.
//    Con teclado no se toca nada: ahi el <summary> tiene que seguir alternando,
//    porque el hover no existe.
document.addEventListener('DOMContentLoaded', function () {
  var elementos = document.querySelectorAll('.header__inline-menu > ul > li');
  var abierto = null;

  // Puntero fino = raton/trackpad. En tactil no hay hover y el <summary> tiene
  // que conservar su comportamiento nativo.
  var hayRaton = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  elementos.forEach(function (item) {
    var detalles = item.querySelector('details');
    if (!detalles) return;
    var disparador = detalles.querySelector('summary');
    var temporizador = null;

    if (hayRaton) {
      item.addEventListener('mouseenter', function () {
        // 🔴 Con el buscador o el cajon abiertos, el HOVER no abre nada. Cerrar
        // un panel que el usuario ha abierto a proposito solo porque el raton
        // ha pasado por encima del menu seria un accidente, no una decision.
        // Para cambiar de panel hay que hacer clic, y de eso se encarga la
        // regla de «uno a la vez» de header.liquid.
        if (document.querySelector('details-modal.header__search > details[open]')) return;
        if (document.body.classList.contains('menu-drawer-open')) return;
        clearTimeout(temporizador);
        if (abierto && abierto !== item) {
          var anterior = abierto.querySelector('details');
          if (anterior) anterior.removeAttribute('open');
        }
        detalles.setAttribute('open', true);
        if (disparador) disparador.setAttribute('aria-expanded', 'true');
        abierto = item;
      });

      item.addEventListener('mouseleave', function () {
        clearTimeout(temporizador);
        temporizador = setTimeout(function () {
          if (!item.matches(':hover')) {
            detalles.removeAttribute('open');
            if (disparador) disparador.setAttribute('aria-expanded', 'false');
            if (abierto === item) abierto = null;
          }
        }, 500);
      });

      if (disparador) {
        disparador.addEventListener('click', function (e) {
          // Abierto por hover: el clic navega o no hace nada, pero NUNCA cierra.
          if (detalles.hasAttribute('open')) e.preventDefault();
        });
      }
    }
  });

  // Escape cierra el que este abierto y devuelve el foco a su disparador.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var abiertos = document.querySelectorAll('.header__inline-menu details[open]');
    if (!abiertos.length) return;
    abiertos.forEach(function (d) {
      d.removeAttribute('open');
      var s = d.querySelector('summary');
      if (s) { s.setAttribute('aria-expanded', 'false'); s.focus(); }
    });
    abierto = null;
  });
});
